<template>
  <div>
    <fieldset>
      <legend>
        {{ $t('serviceRequest.details') }}
        <Tooltip placement="top">
          <Icon type="ios-information-circle-outline" size="17" />
          <div slot="content">
            <div class="ts-text-xs">
              Details.
            </div>
          </div>
        </Tooltip>
      </legend>
      <div class="overflow-auto ts-max-h-40">
        <div class="table-ui-detail">
          <table>
            <thead>
              <tr>
                <th width="2%" class="ts-text-center">
                  {{ $t('no') }}
                </th>
                <th>
                  {{ $t('serviceRequest.barcode') }}
                </th>
                <th>
                  {{ $t('serviceRequest.product') }}
                </th>
                <th class="text-center">
                  {{ $t('serviceRequest.uom') }}
                </th>
                <th class="text-center" width="10%">
                  {{ $t('serviceRequest.unitPrice') }}
                </th>
                <th class="text-center" width="7%">
                  {{ $t('serviceRequest.quantity') }}
                </th>
                <th class="text-center" width="5%">
                  {{ $t('serviceRequest.cusR') }}
                </th>
                <th class="text-center" width="7%">
                  {{ $t('serviceRequest.cusR%') }}
                </th>
                <th class="text-center" width="10%">
                  {{ $t('serviceRequest.amount') }}
                </th>
                <th class="text-center" width="5%">
                  {{ $t('serviceRequest.vendorRes') }}
                </th>
                <th class="text-center" width="7%">
                  {{ $t('serviceRequest.vendor%') }}
                </th>
                <th class="text-center" width="10%">
                  {{ $t('serviceRequest.amount') }}
                </th>
              </tr>
            </thead>
            <tbody v-if="model.details">
              <tr v-for="(detail, index) in model.details" :key="index">
                <td class="ts-whitespace-nowrap ts-text-center">
                  {{ index + 1 }}
                </td>
                <td class="ts-whitespace-nowrap">
                  {{ detail.barcode }}
                </td>
                <td class="ts-whitespace-nowrap">
                  {{ detail.product_name }}
                </td>
                <td class="ts-whitespace-nowrap ts-text-center">
                  {{ detail.uom_name_en }}
                </td>
                <td class="ts-whitespace-nowrap ts-text-center">
                  <ts-currency-input
                    v-model.number="detail.unit_price"
                    class="form-control ts-text-right"
                    :class="{ 'is-invalid': errors.has('unit_price') }"
                    style="min-width: 100px"
                    :currency="default_currency_sign"
                    :precision="default_precision"
                  />
                </td>
                <td class="ts-whitespace-nowrap ts-text-center">
                  {{ detail.quantity }}
                </td>
                <td class="ts-whitespace-nowrap ts-text-center">
                  <input
                    v-model="detail.customer_cover"
                    type="checkbox"
                    @change="e => onChangCustomerCover(detail)"
                  />
                </td>
                <td class="ts-whitespace-nowrap ts-text-center">
                  <input
                    v-model.number="detail.customer_percentage"
                    type="number"
                    :min="0"
                    :max="100"
                    :readonly="!detail.customer_cover"
                    class="form-control ts-text-center"
                    :class="{ 'is-invalid': errors.has('unit_price') }"
                    @input="validateInput(detail)"
                    @change="onChangCustomerPercentage(detail)"
                  />
                </td>
                <td class="ts-whitespace-nowrap ts-text-right">
                  <ts-currency-input
                    v-model.number="detail.customer_amount"
                    class="form-control ts-text-right"
                    style="min-width: 100px"
                    :currency="default_currency_sign"
                    :precision="default_precision"
                    :disabled="true"
                  />
                </td>
                <td class="ts-whitespace-nowrap ts-text-center">
                  <input
                    v-model="detail.vendor_cover"
                    type="checkbox"
                    @change="e => onChangVendorCover(detail)"
                  />
                </td>
                <td class="ts-whitespace-nowrap ts-text-center">
                  <input
                    v-model.number="detail.vendor_percentage"
                    type="number"
                    :min="0"
                    :max="100"
                    :readonly="!detail.vendor_cover"
                    class="form-control ts-text-center"
                    :class="{ 'is-invalid': errors.has('unit_price') }"
                    @input="validateInput(detail)"
                    @change="onChangVendorPercentage(detail)"
                  />
                </td>
                <td class="ts-whitespace-nowrap ts-text-right">
                  <ts-currency-input
                    v-model.number="detail.vendor_amount"
                    class="form-control ts-text-right"
                    style="min-width: 100px"
                    :currency="default_currency_sign"
                    :precision="default_precision"
                    :disabled="true"
                  />
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr style="background-color: #e3e8f1;">
                <td class="ts-whitespace-nowrap" colspan="4">
                  <b>{{ $t('serviceRequest.row') }} : {{ totalRow }}</b>
                </td>
                <td class="ts-whitespace-nowrap ts-text-right">
                  <b>{{ $t('serviceRequest.totalQty') }} :</b>
                </td>
                <td class="ts-whitespace-nowrap ts-text-center">
                  <b>{{ totalQuantity }}</b>
                </td>
                <td class="ts-whitespace-nowrap ts-text-right" colspan="2">
                  <b>{{ $t('serviceRequest.totalAmount') }} :</b>
                </td>
                <td class="ts-whitespace-nowrap ts-text-center">
                  <ts-currency-input
                    v-model.number="model.customer_sub_total"
                    class="form-control ts-text-right"
                    style="min-width: 100px;height:24px;border:transparent;"
                    :currency="default_currency_sign"
                    :precision="default_precision"
                    :disabled="true"
                  />
                </td>
                <td class="ts-whitespace-nowrap ts-text-right" colspan="2">
                  <b>{{ $t('serviceRequest.totalAmount') }} :</b>
                </td>
                <td class="ts-whitespace-nowrap ts-text-center">
                  <ts-currency-input
                    v-model.number="model.vendor_sub_total"
                    class="form-control ts-text-right"
                    style="min-width: 100px;height:24px;border:transparent;"
                    :currency="default_currency_sign"
                    :precision="default_precision"
                    :disabled="true"
                  />
                </td>
              </tr>
              <tr>
                <td
                  colspan="5"
                  rowspan="4"
                  class="ts-align-top"
                  style="border: 1px solid transparent;"
                >
                  <label class="ts-mb-0 required">{{
                    $t('serviceRequest.remarks')
                  }}</label>
                  <textarea
                    v-model="model.remarks"
                    rows="3"
                    class="form-control"
                    placeholder="Note something here"
                  ></textarea>
                </td>
                <td
                  rowspan="4"
                  style="
                  border-left: 1px solid transparent;
                  border-bottom: 1px solid transparent;"
                ></td>
                <td class="ts-whitespace-nowrap ts-text-right" colspan="2">
                  <b>{{ $t('serviceRequest.discount') }} :</b>
                </td>
                <td class="ts-whitespace-nowrap ts-text-center">
                  <ts-currency-input
                    v-model.number="model.customer_discount"
                    class="form-control ts-text-right"
                    style="min-width: 100px;height:24px;"
                    :currency="default_currency_sign"
                    :precision="default_precision"
                  />
                </td>
                <td class="ts-whitespace-nowrap ts-text-right" colspan="2">
                  <b>{{ $t('serviceRequest.discount') }} :</b>
                </td>
                <td class="ts-whitespace-nowrap ts-text-center">
                  <ts-currency-input
                    v-model.number="model.vendor_discount"
                    class="form-control ts-text-right"
                    style="min-width: 100px;height:24px;"
                    :currency="default_currency_sign"
                    :precision="default_precision"
                  />
                </td>
              </tr>
              <tr>
                <td class="ts-whitespace-nowrap ts-text-right" colspan="2">
                  <b>{{ $t('serviceRequest.vat%') }} :</b>
                </td>
                <td class="ts-whitespace-nowrap ts-text-center">
                  <ts-currency-input
                    v-model.number="model.customer_vat_rate"
                    class="form-control ts-text-right"
                    style="min-width: 100px;height:24px;"
                    currency="%"
                    :precision="2"
                  />
                </td>
                <td class="ts-whitespace-nowrap ts-text-right" colspan="2">
                  <b>{{ $t('serviceRequest.vat%') }} :</b>
                </td>
                <td class="ts-whitespace-nowrap ts-text-center">
                  <ts-currency-input
                    v-model.number="model.vendor_vat_rate"
                    class="form-control ts-text-right"
                    style="min-width: 100px;height:24px;"
                    currency="%"
                    :precision="2"
                  />
                </td>
              </tr>
              <tr>
                <td class="ts-whitespace-nowrap ts-text-right" colspan="2">
                  <b>{{ $t('serviceRequest.vatAmount') }} :</b>
                </td>
                <td class="ts-whitespace-nowrap ts-text-center">
                  <ts-currency-input
                    v-model.number="model.customer_vat_amount"
                    class="form-control ts-text-right"
                    style="min-width: 100px;height:24px;"
                    :currency="default_currency_sign"
                    :precision="default_precision"
                    :disabled="true"
                  />
                </td>
                <td class="ts-whitespace-nowrap ts-text-right" colspan="2">
                  <b>{{ $t('serviceRequest.vatAmount') }} :</b>
                </td>
                <td class="ts-whitespace-nowrap ts-text-center">
                  <ts-currency-input
                    v-model.number="model.vendor_vat_amount"
                    class="form-control ts-text-right"
                    style="min-width: 100px;height:24px;"
                    :currency="default_currency_sign"
                    :precision="default_precision"
                    :disabled="true"
                  />
                </td>
              </tr>
              <tr style="color:red">
                <td class="ts-whitespace-nowrap ts-text-right" colspan="2">
                  <b>{{ $t('serviceRequest.grandAmount') }} :</b>
                </td>
                <td class="ts-whitespace-nowrap ts-text-center">
                  <ts-currency-input
                    v-model.number="model.customer_grand_total"
                    class="form-control ts-text-right"
                    style="min-width: 100px;height:24px;color:red"
                    :currency="default_currency_sign"
                    :precision="default_precision"
                    :disabled="true"
                  />
                </td>
                <td class="ts-whitespace-nowrap ts-text-right" colspan="2">
                  <b>{{ $t('serviceRequest.grandAmount') }} :</b>
                </td>
                <td class="ts-whitespace-nowrap ts-text-center">
                  <ts-currency-input
                    v-model.number="model.vendor_grand_total"
                    class="form-control ts-text-right"
                    style="min-width: 100px;height:24px;color:red"
                    :currency="default_currency_sign"
                    :precision="default_precision"
                    :disabled="true"
                  />
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </fieldset>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
  name: 'plannedMaintenance',
  props: ['value', 'validate'],
  data() {
    return {
      errors: new Errors(),
      model: {}
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    ...mapState('serviceManagement/serviceRequest', ['formViewDatas']),
    totalRow() {
      return this.model.details ? this.model.details.length : 0
    },
    totalQuantity() {
      return _.sumBy(this.model.details, 'quantity')
    },
    default_currency_sign() {
      return this.$store.state.authUser.sys_setting.default_currency_sign
    },
    default_precision() {
      return this.$store.state.authUser.sys_setting.decimal_digit
    }
  },
  methods: {
    validateInput(detail) {
      if (detail.customer_percentage < 0) {
        detail.customer_percentage = 0
      } else if (detail.customer_percentage > 100) {
        detail.customer_percentage = 100
      }
      if (detail.vendor_percentage < 0) {
        detail.vendor_percentage = 0
      } else if (detail.vendor_percentage > 100) {
        detail.vendor_percentage = 100
      }
    },
    onChangCustomerCover(detail) {
      if (!detail.customer_cover) {
        if (detail.vendor_cover) {
          detail.vendor_percentage = 100
        }
        detail.customer_percentage = 0
      } else {
        if (!detail.vendor_cover) {
          detail.customer_percentage = 100
        }
      }
    },
    onChangCustomerPercentage(detail) {
      if (detail.vendor_cover) {
        detail.vendor_percentage = 100 - detail.customer_percentage
      }
    },
    onChangVendorCover(detail) {
      if (!detail.vendor_cover) {
        if (detail.customer_cover) {
          detail.customer_percentage = 100
        }
        detail.vendor_percentage = 0
      } else {
        if (!detail.customer_cover) {
          detail.vendor_percentage = 100
        }
      }
    },
    onChangVendorPercentage(detail) {
      if (detail.customer_cover) {
        detail.customer_percentage = 100 - detail.vendor_percentage
      }
    },
    calculate() {
      this.model.details.forEach(detail => {
        //customer_amount
        detail.customer_amount = _.round(
          detail.unit_price *
            detail.quantity *
            (detail.customer_percentage / 100),
          this.default_precision
        )
        //vendor_amount
        detail.vendor_amount = _.round(
          detail.unit_price *
            detail.quantity *
            (detail.vendor_percentage / 100),
          this.default_precision
        )
      })

      this.model.customer_sub_total = _.sumBy(
        this.model.details,
        'customer_amount'
      )

      this.model.customer_total_after_discount =
        this.model.customer_sub_total - this.model.customer_discount

      this.model.customer_vat_amount =
        (this.model.customer_total_after_discount *
          this.model.customer_vat_rate) /
        100

      this.model.customer_grand_total =
        this.model.customer_total_after_discount +
        this.model.customer_vat_amount

      this.model.vendor_sub_total = _.sumBy(this.model.details, 'vendor_amount')

      this.model.vendor_total_after_discount =
        this.model.vendor_sub_total - this.model.vendor_discount

      this.model.vendor_vat_amount =
        (this.model.vendor_total_after_discount * this.model.vendor_vat_rate) /
        100

      this.model.vendor_grand_total =
        this.model.vendor_total_after_discount + this.model.vendor_vat_amount
    }
  },
  watch: {
    'model.details': {
      handler() {
        this.calculate()
      },
      deep: true
    },
    'model.customer_discount': {
      handler() {
        this.calculate()
      },
      deep: true
    },
    'model.vendor_discount': {
      handler() {
        this.calculate()
      },
      deep: true
    },
    'model.customer_vat_rate': {
      handler() {
        this.calculate()
      },
      deep: true
    },
    'model.vendor_vat_rate': {
      handler() {
        this.calculate()
      },
      deep: true
    }
  }
}
</script>
<style scoped>
* {
  font-family: Roboto, Khmer, 'Font Awesome 5 Free';
}
</style>
